<template>
  <div class=" address-page   ">
    <div class="page-form">
      <div class="form-item">
        <div class="label flex-center-start">
          <img :src="bitUrl1" alt="">USDT-TRC20
        </div>
        <div class="input">
          <input type="text" 
                 v-model="form['USDT-TRC20']" 
                 :placeholder="getAddressPlaceholder('USDT-TRC20', 'qing-shu-ru-xu-yao-bang-ding-de-di-zhi-5')"
                 :readonly="isAddressReadonly('USDT-TRC20')"
                 :class="{'readonly': isAddressReadonly('USDT-TRC20')}">
        </div>
        <div class="status" v-if="addressStatus['USDT-TRC20'] === 1">
          <span class="edit" v-if="!editingAddress['USDT-TRC20']" @click="editAddress('USDT-TRC20')">{{ $t('addAddress.edit') }}</span>
          <span class="edit" v-else @click="cancelEditAddress('USDT-TRC20')">{{ $t('common.cancel') }}</span>
        </div>
      </div>
      <div class="form-item">
        <div class="label flex-center-start">
          <img :src="bitUrl1" alt="">USDT-ERC20
        </div>
        <div class="input">
          <input type="text" 
                 v-model="form['USDT-ERC20']" 
                 :placeholder="getAddressPlaceholder('USDT-ERC20', 'qing-shu-ru-xu-yao-bang-ding-de-di-zhi-6')"
                 :readonly="isAddressReadonly('USDT-ERC20')"
                 :class="{'readonly': isAddressReadonly('USDT-ERC20')}">
        </div>
        <div class="status" v-if="addressStatus['USDT-ERC20'] === 1">
          <span class="edit" v-if="!editingAddress['USDT-ERC20']" @click="editAddress('USDT-ERC20')">{{ $t('addAddress.edit') }}</span>
          <span class="edit" v-else @click="cancelEditAddress('USDT-ERC20')">{{ $t('common.cancel') }}</span>
        </div>
      </div>
      <div class="form-item">
        <div class="label flex-center-start">
          <img :src="bitUrl2" alt="">USDC-TRC20
        </div>
        <div class="input">
          <input type="text" 
                 v-model="form['USDC-TRC20']" 
                 :placeholder="getAddressPlaceholder('USDC-TRC20', 'qing-shu-ru-xu-yao-bang-ding-de-di-zhi-7')"
                 :readonly="isAddressReadonly('USDC-TRC20')"
                 :class="{'readonly': isAddressReadonly('USDC-TRC20')}">
        </div>
        <div class="status" v-if="addressStatus['USDC-TRC20'] === 1">
          <span class="edit" v-if="!editingAddress['USDC-TRC20']" @click="editAddress('USDC-TRC20')">{{ $t('addAddress.edit') }}</span>
          <span class="edit" v-else @click="cancelEditAddress('USDC-TRC20')">{{ $t('common.cancel') }}</span>
        </div>
      </div>
      <div class="form-item">
        <div class="label flex-center-start">
          <img :src="bitUrl2" alt="">USDC-ERC20
        </div>
        <div class="input">
          <input type="text" 
                 v-model="form['USDC-ERC20']" 
                 :placeholder="getAddressPlaceholder('USDC-ERC20', 'qing-shu-ru-xu-yao-bang-ding-de-di-zhi-8')"
                 :readonly="isAddressReadonly('USDC-ERC20')"
                 :class="{'readonly': isAddressReadonly('USDC-ERC20')}">
        </div>
        <div class="status" v-if="addressStatus['USDC-ERC20'] === 1">
          <span class="edit" v-if="!editingAddress['USDC-ERC20']" @click="editAddress('USDC-ERC20')">{{ $t('addAddress.edit') }}</span>
          <span class="edit" v-else @click="cancelEditAddress('USDC-ERC20')">{{ $t('common.cancel') }}</span>
        </div>
      </div>
      <div class="form-item">
        <div class="label flex-center-start">
          <img :src="bitUrl3" alt="">ETH-ERC20
        </div>
        <div class="input">
          <input type="text" 
                 v-model="form['ETH-ERC20']" 
                 :placeholder="getAddressPlaceholder('ETH-ERC20', 'qing-shu-ru-xu-yao-bang-ding-de-di-zhi-9')"
                 :readonly="isAddressReadonly('ETH-ERC20')"
                 :class="{'readonly': isAddressReadonly('ETH-ERC20')}">
        </div>
        <div class="status" v-if="addressStatus['ETH-ERC20'] === 1">
          <span class="edit" v-if="!editingAddress['ETH-ERC20']" @click="editAddress('ETH-ERC20')">{{ $t('addAddress.edit') }}</span>
          <span class="edit" v-else @click="cancelEditAddress('ETH-ERC20')">{{ $t('common.cancel') }}</span>
        </div>
      </div>
      <div class="form-item">
        <div class="label flex-center-start">
          <img :src="bitUrl4" alt="">BTC
        </div>
        <div class="input">
          <input type="text" 
                 v-model="form['BTC']" 
                 :placeholder="getAddressPlaceholder('BTC', 'qing-shu-ru-xu-yao-bang-ding-de-di-zhi-10')"
                 :readonly="isAddressReadonly('BTC')"
                 :class="{'readonly': isAddressReadonly('BTC')}">
        </div>
        <div class="status" v-if="addressStatus['BTC'] === 1">
          <span class="edit" v-if="!editingAddress['BTC']" @click="editAddress('BTC')">{{ $t('addAddress.edit') }}</span>
          <span class="edit" v-else @click="cancelEditAddress('BTC')">{{ $t('common.cancel') }}</span>
        </div>
      </div>

      <div class="btn" v-if="canShowSubmitButton">
        <Button @click="submit">{{ $t('addAddress.btn1') }}</Button>
      </div>
    </div>


  </div>
</template>
<script>
import { Button } from 'vant'
import { addressList } from '@/api/setting'
import { bindWithdrawAddress, updateWithdrawAddress } from '@/api/assest'
import {
  collectWithdrawAddressSubmissions,
  getWithdrawAddressEditValue
} from '@/utils/withdrawAddressForm'
export default {
  components: {
    Button
  },
  data() {
    return {
      form: {
        'USDT-TRC20': '',
        'USDT-ERC20': '',
        'USDC-TRC20': '',
        'USDC-ERC20': '',
        'ETH-ERC20': '',
        'BTC': '',
      },
      addressStatus: {
        'USDT-TRC20': 2, // 2=未绑定, 1=已绑定
        'USDT-ERC20': 2,
        'USDC-TRC20': 2,
        'USDC-ERC20': 2,
        'ETH-ERC20': 2,
        'BTC': 2,
      },
      editingAddress: {
        'USDT-TRC20': false,
        'USDT-ERC20': false,
        'USDC-TRC20': false,
        'USDC-ERC20': false,
        'ETH-ERC20': false,
        'BTC': false,
      },
      originalAddresses: {}, // 存储原始完整地址
      originalAddressIds: {},
      email: 'akdfjlaskjaskjdfasdj@163.com',
      bitUrl1:  require('../../assets/imgs/bit1.png'),
      bitUrl2:  require('../../assets/imgs/bit2.png'),
      bitUrl3:  require('../../assets/imgs/bit3.png'),
      bitUrl4:  require('../../assets/imgs/bit4.png'),
      pageType: '',
      bitList: ['USDT-TRC20', 'USDT-ERC20', 'USDC-TRC20', 'USDC-ERC20', 'ETH-ERC20', 'BTC'],
      hideAdd: false,
      submitting: false
    }
  },
  computed: {
    // 是否有未绑定的地址
    hasUnboundAddress() {
      return Object.values(this.addressStatus).some(status => status === 2)
    },
    hasEditingAddress() {
      return Object.values(this.editingAddress).some(isEditing => isEditing)
    },
    canShowSubmitButton() {
      return this.hasUnboundAddress || this.hasEditingAddress
    }
  },
  mounted() {
    this.pageType = this.$route.query.type
    this.init()
  },
  methods: {
    resetAddressState() {
      this.bitList.forEach(protocol => {
        this.form[protocol] = ''
        this.addressStatus[protocol] = 2
        this.editingAddress[protocol] = false
      })
      this.originalAddresses = {}
      this.originalAddressIds = {}
    },
    init() {
      this.resetAddressState()
      addressList({
        current: 1,
        pageSize: 30
      }).then(res => {
        let cardList = (res.data && res.data.Items) || []
        cardList.forEach(v => {
          let index = this.bitList.findIndex(val => {
            return val == v.Protocol
          })
          if (index > -1) {
            // 保存原始完整地址
            this.originalAddresses[v.Protocol] = v.Address
            this.originalAddressIds[v.Protocol] = v.ID
            // 显示隐藏地址
            this.form[v.Protocol] = this.resetAddress(v.Address)
            // 设置为已绑定状态
            this.addressStatus[v.Protocol] = 1
          }
        })
      })
    },
    back() {
      this.$router.go(-1)
    },
    chooseCard(data) {
      if (this.pageType == 'withdraw') {
        sessionStorage.setItem('withdrawInfo', JSON.stringify(data))
        this.back()
      }
    },
    resetAddress(address) {
      if (!address || address.length < 16) return address
      return address.substring(0, 8) + '********' + address.substring(address.length - 8)
    },
    isAddressReadonly(protocol) {
      return this.addressStatus[protocol] === 1 && !this.editingAddress[protocol]
    },
    getAddressPlaceholder(protocol, placeholderKey) {
      return this.isAddressReadonly(protocol) ? '' : this.$t(placeholderKey)
    },
    editAddress(protocol) {
      if (this.addressStatus[protocol] !== 1) return
      this.editingAddress[protocol] = true
      this.form[protocol] = getWithdrawAddressEditValue(this.originalAddresses, protocol)
    },
    cancelEditAddress(protocol) {
      this.editingAddress[protocol] = false
      this.form[protocol] = this.resetAddress(this.originalAddresses[protocol])
    },
    async submit() {
      if (this.submitting) return
      
      const withdrawAddresses = collectWithdrawAddressSubmissions(
        this.addressStatus,
        this.form,
        this.editingAddress,
        this.originalAddressIds
      )
      
      if (Object.keys(withdrawAddresses.bind).length === 0 && Object.keys(withdrawAddresses.update).length === 0) {
        this.$toast.fail(this.$t('addAddress.addressRequired'))
        return
      }

      this.submitting = true
      
      try {
        const bindPromises = []
        
        for (const [protocol, address] of Object.entries(withdrawAddresses.bind)) {
          const form = new FormData()
          form.append('Address', address)
          form.append('Protocol', protocol)
          
          bindPromises.push(bindWithdrawAddress(form))
        }

        for (const addressInfo of Object.values(withdrawAddresses.update)) {
          const form = new FormData()
          form.append('Id', addressInfo.id)
          form.append('Address', addressInfo.address)
          
          bindPromises.push(updateWithdrawAddress(form))
        }

        if (bindPromises.length > 0) {
          const results = await Promise.all(bindPromises)
          
          // 检查是否有失败的请求
          const failedResults = results.filter(res => res.code !== 0)
          
          if (failedResults.length === 0) {
            this.$toast.success(this.$t('common.success'))
            setTimeout(() => {
              sessionStorage.setItem('withdrawInit', 1)
              this.init() // 重新获取数据
              
              // 如果是从提现页面跳转过来的，返回提现页面
              if (this.$route.query.from === 'withdraw') {
                this.$router.go(-1)
              }
            }, 1500)
          } else {
            // 显示第一个错误信息
            this.$toast.fail(failedResults[0].msg)
          }
        }
      } catch (error) {
        console.error(this.$t('addAddress.bindFailed'), error)
        this.$toast.fail(this.$t('addAddress.bindFailed'))
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.form-item {
  position: relative;
}

.form-item .input input.readonly {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.form-item .input input {
  padding-right: 70px;
}

.form-item .status {
  position: absolute;
  right: 10px;
  top: 48px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
}

.status .success {
  color: #4CAF50;
  font-size: 12px;
}

.status .edit {
  color: #2F80ED;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
}
</style>
